module.exports = __webpack_public_path__ + "static/media/heart.79790194.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/heart.png
// module id = 304
// module chunks = 0